// extracted by mini-css-extract-plugin
export default {"tools":"product-strategy-module--tools--p3HqX","parallax":"product-strategy-module--parallax--0-o1l"};